/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable max-len */
import { Row } from 'antd';
import React, { HTMLProps, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import Loader from '~/components/Loader/Loader';
import { SetupAuthPaymentBody } from '~/services/CyberSourceService';

import './CollectDataForm.scss';

export interface CollectDataFormProps extends HTMLProps<HTMLFormElement> {
  selectedItem?: number;
  loading?: boolean;
  redirect: string;
  accessToken: string;
  setupAuthPaymentBody: SetupAuthPaymentBody;
  pay: (setupAuthPaymentBody: SetupAuthPaymentBody) => void;
}

const CollectDataForm: React.FC<CollectDataFormProps> = ({
  loading,
  redirect,
  accessToken,
  pay,
  setupAuthPaymentBody,
}) => {
  const { t } = useTranslation();

  const formulaireRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    // console.log('');
    window.addEventListener(
      'message',
      event => {
        // console.log('event', event);
        // console.log('event.data', event.data);
        // localStorage.setItem('collectData', JSON.stringify(event));
        // localStorage.setItem('collectDataEvent', JSON.stringify(event.data));
        if (
          event.origin === 'https://centinelapi.cardinalcommerce.com' ||
          event.origin === 'https://client.cardinaltrusted.com'
        ) {
          // https://centinelapistag.cardinalcommerce.com
          if (event.data !== null) {
            const data = JSON.parse(event.data);
            if (data.Status === true) {
              pay(setupAuthPaymentBody);
            }
            // console.log('event.data not null', event.data);
          }
          // console.log('event.data', event.data);
        }
      },
      false,
    );
    if (formulaireRef.current) {
      formulaireRef.current.submit();
    }
  }, []);

  return (
    <div className="collect-payment-form">
      {/* <div className={cn('caption-wrapper')}>
        <Text className="caption" size="s" weight={FontWeight.MEDIUM} variant={TextVariants.PRIMARY}>
          {'Collect Device infos'}
        </Text>
      </div> */}
      <Row justify="center">
        <Loader />
      </Row>
      <div className="form-wrapper">
        <iframe
          name="ddc-iframe"
          id="cardinal_collection_iframe"
          height="10"
          width="10"
          style={{ display: 'none' }}
        ></iframe>
        <form ref={formulaireRef} id="cardinal_collection_form" method="POST" target="ddc-iframe" action={redirect}>
          <input id="cardinal_collection_form_input" type="hidden" name="JWT" value={accessToken} />
        </form>
      </div>
    </div>
  );
};

export default CollectDataForm;
